import type { EnumInfoCollection } from '_types/enums';

export enum ErrorCode {
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    VALIDATION_ERROR = 422,
    TOO_MANY_REQUESTS = 429,

    ERROR = 500,
}

export const ErrorCodeInfo = {
    [ErrorCode.UNAUTHORIZED]: {
        label: 'Não autenticado',
        value: ErrorCode.UNAUTHORIZED,

        title: '🚫 Não autenticado',
        description: 'Não conseguimos lhe identificar.',
        // actions: <UnauthorizedActions />,
    },
    [ErrorCode.FORBIDDEN]: {
        label: 'Acesso proibido',
        value: ErrorCode.FORBIDDEN,

        title: '🚫 Acesso proibido',
        description: 'Você não tem permissões suficientes para acessar este conteúdo.',
        // actions: <ForbiddenActions />,
    },
    [ErrorCode.NOT_FOUND]: {
        label: 'Não encontrado',
        value: ErrorCode.NOT_FOUND,

        title: '🔍❓ Não encontrado',
        description: 'Não encontramos o conteúdo que você estava procurando.',
        // actions: <NotFoundActions />,
    },
    [ErrorCode.VALIDATION_ERROR]: {
        label: 'Erro de validação',
        value: ErrorCode.VALIDATION_ERROR,

        title: '⚠️ Erro de validação',
        description: 'A validação dos dados enviados falhou.',
        // actions: <ValidationErrorActions />,
    },
    [ErrorCode.TOO_MANY_REQUESTS]: {
        label: 'Limite de uso excedido',
        value: ErrorCode.TOO_MANY_REQUESTS,

        title: 'Limite de uso excedido 🕘',
        description: 'Você excedeu o limite de ações por minuto. Por favor, aguarde.',
        actions: null,
    },
    [ErrorCode.ERROR]: {
        label: 'Erro',
        value: ErrorCode.ERROR,

        title: '💥 Erro',
        description: 'Encontramos um erro desconhecido.',
        // actions: <ServerErrorActions />,
    },
} as const satisfies EnumInfoCollection<ErrorCode>;
